import { createApp } from 'vue'
import FArticleFilter from '~/js/components/articleFilter'
import FLinkCard from '~/js/components/linkCard'
import FPaginator from '~/js/components/paginator'
import { LinkItem } from '~/js/models/linkItem'
import { favouriteCoordinateHandles } from '~/js/templates/index/helpers'
import { isDesktop } from '~/js/templates/index/helpers'

const ID = 'js-blogCoordinate'

document.addEventListener('DOMContentLoaded', () => {
  const elementBlogCoordinate = document.getElementById(ID)
  if (!elementBlogCoordinate) return

  const { blogHandle } = elementBlogCoordinate.dataset
  const baseUrl = `/blogs/${blogHandle}`

  const postByArray = JSON.parse(elementBlogCoordinate.dataset.postByArray)
  const linkItems = JSON.parse(elementBlogCoordinate.dataset.linkItems).map(
    (linkItem, index) => {
      const url = `${baseUrl}/${linkItem.handle}`
      const isFavourite = favouriteCoordinateHandles.includes(linkItem.handle)
      const labels = postByArray[index] ? [postByArray[index]] : []
      return new LinkItem({ ...linkItem, labels }, url, isFavourite)
    }
  )

  createApp({
    name: 'TemplatesBlogCoordinate',
    components: {
      FArticleFilter,
      FLinkCard,
      FPaginator,
    },
    data() {
      return {
        baseUrl,
        linkItems,
        textBottom: isDesktop() ? '' : 'このコーディネートを見る>',
      }
    },
  }).mount(elementBlogCoordinate)
})
